module.exports = __webpack_public_path__ + "backend1.png?ead7f84066d32dcdcaaff4b28ad7b0c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backend1.png
// module id = 807
// module chunks = 0